import request from '@/request'

export const addMoments = data => {
  return request({
    url: '/mobile_MobMoments/addMoments.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const getList = data => {
  return request({
    url: '/mobile_MobMoments/list.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getList1 = data => {
  return request({
    url: '/mobile_MobMoments/stickieList.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getList2 = data => {
  return request({
    url: '/mobile_MobMoments/list.action?heat=1',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const addLiked = data => {
  return request({
    url: '/mobile_MobMoments/addLiked.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const deleteLiked = data => {
  return request({
    url: '/mobile_MobMoments/deleteLiked.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const addCredit = data => {
  return request({
    url: '/mobile_MobMoments/addCredit.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const myMessage = data => {
  return request({
    url: '/mobile_MobMoments/myMessage.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const myAll = data => {
  return request({
    url: '/mobile_MobMoments/myAll.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const checkAdd = data => {
  return request({
    url: '/mobile_MobMoments/checkAdd.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const getCheckType = data => {
  return request({
    url: '/mobile_SysDd/FTU_MOMENTS_CHECKTYPE.action',
    method: 'post',
    data,
    isMd5: false
  })
}

export const getBase = data => {
  return request({
    url: '/mobile_MobMoments/base.action',
    method: 'post',
    data,
    isMd5: false
  })
}

export const deleteMoments = data => {
  return request({
    url: '/mobile_MobMoments/deleteMoments.action',
    method: 'post',
    data,
    isMd5: false
  })
}

export const checkList = data => {
  return request({
    url: '/mobile_MobMoments/checkList.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const checkListQc = data => {
  return request({
    url: '/mobile_MobMoments/checkListQc.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const updateBackgroundImageId = data => {
  return request({
    url: '/mobile_MobMoments/updateBackgroundImageId.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const uploadFile = data => {
  return request({
    url: '/mobile_MobMoments/uploadFile.action',
    method: 'post',
    data,
    isMd5: false,
    contentType: 'multipart/form-data'
  })
}
export const stickie = data => {
  return request({
    url: '/mobile_MobMoments/stickie.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const unstickie = data => {
  return request({
    url: '/mobile_MobMoments/unstickie.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 新增评论
export const addComment = data => {
  return request({
    url: '/exterior_intFtuMomentComment/addComment.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 删除评论
export const deleteComment = data => {
  return request({
    url: '/exterior_intFtuMomentComment/deleteComment.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 举报评论
export const commentTip = data => {
  return request({
    url: '/exterior_intFtuMomentCommentTip/commentTip.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 举报类型
export const complaintlist = data => {
  return request({
    url: '/sysDd/FTU_productComplaint_TYPE.action',
    method: 'get',
    data,
    isMd5: false
  })
}
